<template>
<div class="l-container-content bg-white">
    <div class="row">
        <div class="col">
            <div class="text-title">
                <h3>Add Games</h3>
            </div>
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div v-show="successcreateStatus">
                <small class="text-success">{{successMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-4">
                    <label>Game Name</label>
                    <input type="text" v-model="gameName" placeholder="Enter Game">
                </div>
                <div class="col-4">
                    <label>Game Code</label>
                    <input type="text" v-model="gameCode" placeholder="Enter Game Code">
                </div>
                <div class="col-4">
                    <label>Select Game Type</label>
                    <select v-model="gameTypeId">
                        <option value>Select Game Type</option>
                        <option value="1">Slot</option>
                        <option value="2">Table</option>
                        <option value="3">Virtuals</option>
                        <option value="4">Live</option>
                        <option value="5">Hot</option>
                        <option value="6">Most Popular</option>
                    </select>
                </div>
                <div class="col-4">
                    <label>Select Partner</label>
                    <select v-model="gameProviderId">
                        <option value>Select Game Type</option>
                        <option value="1">BETXION</option>
                        <option value="2">EVO PLAY GAMING</option>
                        <option value="3">CHEZA Play</option>
                    </select>
                </div>
                <div class="col-4">
                    <label>Game Mode (light/Heavy)</label>
                     <select v-model="dataSaver">
                        <option value>Select Game Mode</option>
                        <option value="1">Light</option>
                        <option value="0">Heave</option>
                    </select>
                </div>
                 <div class="col-4">
                    <label>Game Priority (1 - 15)</label>
                     <input type="number" v-model="priority" min="1" max="15">
                </div>
                <div class="col-10">
                    <label>Image URL</label>
                    <input type="url" v-model="gameImageUrl" placeholder="Enter Image URL">
                </div>
                
                <div class="col">
                    <button class="button primary" id="createUser" @click="createGames()">Create Game</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import store from "../store";
import loader from "@/components/loader";
import $ from "jquery";
export default {
    data: function () {
        return {
            gameName: "",
            gameCode: "",
            gameTypeId: "",
            gameProviderId: "",
            dataSaver: 1,
            priority: 8,
            errorcreateStatus: false,
            successcreateStatus: false,
            errorsMessage: "",
            successMessage: ""
        };
    },
    mounted() {
        let vm = this;
        // if (vm.$cookies.get("role_id") != 4) {
        //   vm.$router.push({ name: "dashboard" });
        // }
    },
    components: {
        loader
    },
    methods: {
        createGames() {
            $("#createUser").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            let vm = this;
            vm.errorcreateStatus = false;
            vm.successcreateStatus = false;
            vm.successMessage = "";
            vm.errorsMessage = "";
            $.post({
                url: store.state.rootUrl + 'portal/v1/game/add',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    gameName:vm.gameName,
                    gameCode: vm.gameCode,
                    gameTypeId: vm.gameTypeId,
                    gameProviderId: vm.gameProviderId,
                    gameImageUrl: vm.gameImageUrl,
                    dataSaver: vm.dataSaver,
                    priority: vm.priority
                }),
                success: function (response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createUser").text("Create Game");
                    if(response.data.code == 200){
                        vm.errorcreateStatus = false;
                        vm.successcreateStatus = true;
                        vm.successMessage = response.data.message;
                    }
                    else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                    // swal("Success!", "Access Granted!", "success");

                },
                error: function (jQxhr, status, error) {
                  $("#createUser").text("Create Game");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
          vm.successcreateStatus = false;
          vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        }
    }
};
</script>
